const fontFamily = {
  workSans: "Work Sans",
};

export default fontFamily;
